export interface ITypography {
  fontFamily: string;
  large: {
    fontSize1: string;
    fontSize2: string;
    fontSize3: string;
    fontSizeH1: string;
    fontSizeH2: string;
    fontSizeH3: string;
    fontSizeH4: string;
    fontSizeH5: string;
    fontSizeH6: string;
    lineHeight1: string;
    lineHeight2: string;
    lineHeight3: string;
    lineHeightH1: string;
    lineHeightH2: string;
    lineHeightH3: string;
    lineHeightH4: string;
    lineHeightH5: string;
    lineHeightH6: string;
  };
  fontSize1: string;
  fontSize2: string;
  fontSize3: string;
  fontSizeH0: string;
  fontSizeH1: string;
  fontSizeH2: string;
  fontSizeH3: string;
  fontSizeH4: string;
  lineHeight1: string;
  lineHeight2: string;
  lineHeight3: string;
  lineHeightH0: string;
  lineHeightH1: string;
  lineHeightH2: string;
  lineHeightH3: string;
  lineHeightH4: string;
}

export const Typography: ITypography = {
  fontFamily: '"Proxima Nova", sans-serif',
  large: {
    fontSize1: "17px",
    fontSize2: "15px",
    fontSize3: "13px",
    fontSizeH1: "44px",
    fontSizeH2: "36px",
    fontSizeH3: "32px",
    fontSizeH4: "28px",
    fontSizeH5: "24px",
    fontSizeH6: "20px",
    lineHeight1: "24px",
    lineHeight2: "20px",
    lineHeight3: "16px",
    lineHeightH1: "48px",
    lineHeightH2: "40px",
    lineHeightH3: "36px",
    lineHeightH4: "32px",
    lineHeightH5: "28px",
    lineHeightH6: "24px",
  },
  fontSize1: "16px",
  fontSize2: "14px",
  fontSize3: "12px",
  fontSizeH0: "32px",
  fontSizeH1: "28px",
  fontSizeH2: "24px",
  fontSizeH3: "20px",
  fontSizeH4: "16px",
  lineHeight1: "24px",
  lineHeight2: "20px",
  lineHeight3: "16px",
  lineHeightH0: "36px",
  lineHeightH1: "32px",
  lineHeightH2: "28px",
  lineHeightH3: "24px",
  lineHeightH4: "20px",
};
